module.exports = __webpack_public_path__ + "static/media/lottery-prizes-mobile-routes.62ce4e5c.png";